import React from "react";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";

const LovPermissionsMenu: React.FC<Omit<IComponentSelect, "options">> = ({
	name,
	label,
	control,
	...rest
}) => {
	const {translate} = useTranslation();
	return (<Select 
		name={name}
		control={control}
		label={label}
		options={[
			{ value: PermissionEnum.VIEW.toString(), label: `${translate("Visualiza")}` },
			{ value: PermissionEnum.CREATE_UPDATE.toString(), label: `${translate("Cria e edita")}` },
			{ value: PermissionEnum.CREATE_UPDATE_DELETE.toString(), label: `${translate("Cria, edita e exclui")}` },
			{ value: PermissionEnum.NO_ACCESS.toString(), label: `${translate("Sem acesso")}` }
		]}
		{...rest}
	/>);
};

export default LovPermissionsMenu;
